import './ApiError.sass'

import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { Button } from '@sm/wds-react'
import { IconArrowRefresh } from '@sm/wds-icons'

export const ApiError = props => {
  const { t, reload, passwordExpired } = props

  // Don't show error screen when password is expired - modal will handle it
  if (passwordExpired) {
    return null
  }

  return (
    <div className='api-error'>
      <h4>{t('api_error')}</h4>
      <Button onClick={reload}>
        <IconArrowRefresh />
        {t('retry')}
      </Button>
    </div>
  )
}

ApiError.propTypes = {
  reload: PropTypes.func.isRequired,
  t: PropTypes.func,
  passwordExpired: PropTypes.bool
}

const mapStateToProps = state => ({
  passwordExpired: state.app.passwordExpired
})

export default connect(mapStateToProps)(withTranslation('global')(ApiError))
